import {HttpClient, HttpParams} from '@angular/common/http';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {Component} from '@angular/core';
import * as moment from 'moment-timezone';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {ParksFetcher} from '@app/app/shared/helpers/parks.fetcher';
import {WebHttpUrlEncodingCodec} from '@app/app/shared/helpers/web.http.url.encoding.codec';

@Component({
  selector: 'app-reports',
  styleUrls: ['../reports.css'],
  templateUrl: './reports.crowd.component.html'
})
export class ReportsCrowdComponent {
  chartOption1 = {};
  chartOption2 = {};
  chartOption3 = {};

  public parks = [];
  public activators = [];

  public selectedParks = [];
  public selectedActivators = [];
  public selectedFromDate = null;
  public selectedToDate = null;
  public selectedActivatorsType = null;

  public minDate = new Date(1960, 0, 1);
  public maxDate = new Date(2100, 0, 1);

  public isLoadingResults = false;

  public width = '100%';
  public height = 400;

  public stats;

  parseFloat = parseFloat;

  constructor(private http: HttpClient, private auth: AuthenticationService,
              private parksFetcher: ParksFetcher) {
    this.selectedFromDate = moment().startOf('year').toDate();
    this.selectedToDate = moment().endOf('day').toDate();
    this.selectedActivatorsType = 'sequence_activations';
    this.selectedActivators = [''];

    try {
      const parks = JSON.parse(sessionStorage.getItem('parks'));

      if (Array.isArray(parks) && parks.length > 0 && parks.length < 3) {
        this.selectedParks = parks;
      }
    } catch (e) {
      console.log(e);
    }

    this.isLoadingResults = true;

    this.parksFetcher.retrieveParks().subscribe((res) => {
      this.parks = res;

      if (Array.isArray(this.parks) && this.parks.length > 0) {
        if (this.selectedParks.length < 1) {
          this.selectedParks.push(this.parks[0].id);
        }

        this.reloadActivators();

        this.reloadData();
      }
    }, (err) => {
      this.isLoadingResults = false;
    });
  }

  setStartDate(event) {
    this.selectedFromDate = moment(event.value).startOf('day').toDate();
    this.reloadData();
  }

  setEndDate(event) {
    this.selectedToDate = moment(event.value).endOf('day').toDate();
    this.reloadData();
  }

  setActivatorType(event) {
    this.selectedActivatorsType = event.trim();

    if (this.selectedActivatorsType === 'daily_usage') {
      this.selectedActivators = [];
    } else if (this.selectedActivators.length < 1 && this.activators.length > 0) {
      this.selectedActivators = [''];
    }

    this.reloadData();
  }

  setActivator(event) {
    this.selectedActivators = event;
    this.reloadData();
  }

  setPark(value) {
    this.selectedParks = value;

    sessionStorage.setItem('parks', JSON.stringify(this.selectedParks));

    this.reloadActivators();
    this.reloadData();
  }

  checkAvailabilityForSelectFor(value) {
    if (value === 'park') {
      if (this.selectedParks.length === 2) {
        return false;
      } else if (this.selectedParks.length === 0) {
        return true;
      } else if (this.selectedParks.length <= 2 && this.selectedActivators.length <= 1) {
        return true;
      }
    } else if (value === 'activator') {
      if (this.selectedActivatorsType === 'daily_usage') {
        return false;
      }

      if (this.selectedActivators.length === 2) {
        return false;
      } else if (this.selectedActivators.length === 0) {
        return true;
      } else if (this.selectedActivators.length <= 2 && this.selectedParks.length <= 1) {
        return true;
      }
    }
    return false;
  }

  private getPark() {
    const parks = [];

    this.selectedParks.forEach(sPark => {
      this.parks.forEach((park) => {

        if (park.id === sPark) {
          parks.push(park);
        }
      });
    });

    return parks;
  }

  private reloadActivators() {
    this.activators = [];

    const parks = this.getPark();

    parks.forEach(park => {
      if (park.hasOwnProperty('attributes') && park.attributes.hasOwnProperty('shadow') && park.attributes.shadow !== null) {
        if (park.attributes.shadow.hasOwnProperty('activators')) {
          Object.keys(park.attributes.shadow.activators).forEach((activatorId) => {
            const activator = park.attributes.shadow.activators[activatorId];
  
            let exists = false;
  
            this.activators.forEach((act) => {
              if (act.id === activatorId) {
                exists = true;
              }
            });
  
            if (!exists) {
              this.activators.push({id: activatorId, label: activator.nm});
            }
          });
        }

        if (park.attributes.shadow.hasOwnProperty('activators-logic')) {
          Object.keys(park.attributes.shadow['activators-logic']).forEach((activatorId) => {
            const activator = park.attributes.shadow['activators-logic'][activatorId];
  
            let exists = false;
  
            this.activators.forEach((act) => {
              if (act.id === activatorId) {
                exists = true;
              }
            });
  
            if (!exists) {
              this.activators.push({id: activatorId, label: activator.nm});
            }
          });
        }
      } 
    });

    if (this.activators.length > 0) {
      this.activators.push({id: '', label: 'All activators'});
    }
  }

  private prepareDate(date) {
    return moment(date).valueOf();
  }

  private prepareParams1(selectedActivator, selectedPark) {
    let params =  new HttpParams({encoder: new WebHttpUrlEncodingCodec()})
      .set('type', this.selectedActivatorsType)
      .set('timestamps[from]', this.prepareDate(this.selectedFromDate))
      .set('timestamps[to]', this.prepareDate(this.selectedToDate))
      .set('source', selectedActivator)
      .set('parks[]', selectedPark)
      .set('agg[parent]', 'hour')
      .set('agg[child]', 'hour');

    return params;
  }

  private prepareParams2(selectedActivator, selectedPark) {
    let params =  new HttpParams({encoder: new WebHttpUrlEncodingCodec()})
      .set('type', this.selectedActivatorsType)
      .set('timestamps[from]', this.prepareDate(this.selectedFromDate))
      .set('timestamps[to]', this.prepareDate(this.selectedToDate))
      .set('source', selectedActivator)
      .set('parks[]', selectedPark)
      .set('agg[parent]', 'week')
      .set('agg[child]', 'hour');

    return params;
  }

  private prepareParams3(selectedActivator, selectedPark) {
    let params = new HttpParams({encoder: new WebHttpUrlEncodingCodec()})
      .set('type', this.selectedActivatorsType)
      .set('parks[]', selectedPark)
      .set('timestamps[from]', this.prepareDate(this.selectedFromDate))
      .set('timestamps[to]', this.prepareDate(this.selectedToDate))
      .set('source', selectedActivator);

    if (this.selectedActivatorsType === 'occupancy') {
      params = params.append('agg[parent]', 'month');
      params = params.append('agg[child]', 'week');
    }

    return params;
  }

  private prepareStatsParams() {
    let params = new HttpParams({encoder: new WebHttpUrlEncodingCodec()})
      .set('timestamps[from]', this.prepareDate(this.selectedFromDate))
      .set('timestamps[to]', this.prepareDate(this.selectedToDate))
      .set('type', this.selectedActivatorsType);

    this.selectedParks.forEach((selectedPark) => {
      params = params.append('parks[]', selectedPark);
    });

    this.selectedActivators.forEach((selectedActivator) => {
      params = params.append('source', selectedActivator);
    });

    return params;
  }

  private prepareCaption(selectedActivator, selectedPark) {
    let c = '';

    this.activators.forEach(act => {
      if (act.id === selectedActivator) {
        c = act.label;
      }
    });

    let pp = ' for ';

    this.parks.forEach((park) => {
      if (park.id === selectedPark) {
        pp += park.attributes.name;
      }
    });

    return c + pp;
  }

  private getData1(selectedActivator, selectedPark) {
    return this.http.get<any>('/reports/crowd', {params: this.prepareParams1(selectedActivator, selectedPark)});
  }

  private getData2(selectedActivator, selectedPark) {
    return this.http.get<any>('/reports/crowd', {params: this.prepareParams2(selectedActivator, selectedPark)});
  }

  private getData3(selectedActivator, selectedPark) {
    return this.http.get<any>('/reports/crowd', {params: this.prepareParams3(selectedActivator, selectedPark)});
  }

  private reloadData() {
    if (this.selectedParks.length > 0 && this.selectedActivatorsType !== 'occupancy') {
      this.http.get<any>('/reports/crowd/statistics', {params: this.prepareStatsParams()}).subscribe(
        (res) => {
          this.stats = res;
        },
        (err) => {
          //
        },
        () => {
          //
        }
      );
    }

    if (this.selectedActivatorsType !== 'daily_usage' && this.selectedActivators.length < 1) {
      return;
    }

    const req = [];

    const actCount = this.selectedActivators.length;
    const parCount = this.selectedParks.length;

    if (parCount === 1 && actCount === 1) {
      req.push(this.getData1(this.selectedActivators[0], this.selectedParks[0]));
      req.push(this.getData2(this.selectedActivators[0], this.selectedParks[0]));
      req.push(this.getData3(this.selectedActivators[0], this.selectedParks[0]));
    } else if (parCount === 2 && actCount === 1) {
      this.selectedParks.forEach(selectedPark => {
        req.push(this.getData1(this.selectedActivators[0], selectedPark));
        req.push(this.getData2(this.selectedActivators[0], selectedPark));
        req.push(this.getData3(this.selectedActivators[0], selectedPark));
      });
    } else if (parCount === 1 && actCount === 2) {
      this.selectedActivators.forEach(selectedActivator => {
        req.push(this.getData1(selectedActivator, this.selectedParks[0]));
        req.push(this.getData2(selectedActivator, this.selectedParks[0]));
        req.push(this.getData3(selectedActivator, this.selectedParks[0]));
      });
    } else {
      this.selectedParks.forEach(selectedPark => {
        req.push(this.getData1('', selectedPark));
        req.push(this.getData2('', selectedPark));
        req.push(this.getData3('', selectedPark));
      });
    }

    this.isLoadingResults = true;

    forkJoin(req).subscribe((results) => {
      this.isLoadingResults = false;
      let dataLabels1 = [];
      const series1 = [];
      const legend1 = [];

      let dataLabels2 = [];
      const series2 = [];
      const legend2 = [];

      let dataLabels3 = [];
      const series3 = [];
      const legend3 = [];

      results.forEach((data: any, index) => {
        const p = (parCount > 1 && index > 2) ? 1 : 0;
        const a = (actCount > 1 && index > 2) ? 1 : 0;

        switch (index) {
          case 0:
          case 3:
            dataLabels1 = data.labels.length > 0 ? data.labels : dataLabels1;

            legend1.push(this.prepareCaption(this.selectedActivators[a], this.selectedParks[p]));

            const vals = [];

            data.values.forEach(val => {
              vals.push({value: val, label: {show: false, position: 'top', rotate: 90, offset: [8, -20], color: '#000'}});
            });

            series1.push({
              name: this.prepareCaption(this.selectedActivators[a], this.selectedParks[p]),
              type: 'bar',
              barGap: 0.1,
              label: this.prepareCaption(this.selectedActivators[a], this.selectedParks[p]),
              data: vals
            });

            break;
          case 1:
          case 4:
            dataLabels2 = data.labels.length > 0 ? data.labels : dataLabels2;

            legend2.push(this.prepareCaption(this.selectedActivators[a], this.selectedParks[p]));

            const vals2 = [];

            data.values.forEach(val => {
              vals2.push({value: val, label: {show: false, position: 'top', rotate: 90, offset: [8, -20], color: '#000'}});
            });

            series2.push({
              name: this.prepareCaption(this.selectedActivators[a], this.selectedParks[p]),
              type: 'bar',
              barGap: 0.1,
              label: this.prepareCaption(this.selectedActivators[a], this.selectedParks[p]),
              data: vals2
            });

            break;
          case 2:
          case 5:
            dataLabels3 = data.labels.length > 0 ? data.labels : dataLabels3;

            legend3.push(this.prepareCaption(this.selectedActivators[a], this.selectedParks[p]));
  
            const vals3 = [];
  
            data.values.forEach(val => {
              vals3.push({value: val, label: {show: false, position: 'top', rotate: 90, offset: [8, -20], color: '#000'}});
            });
  
            series3.push({
              name: this.prepareCaption(this.selectedActivators[a], this.selectedParks[p]),
              type: 'line',
              barGap: 0.1,
              label: this.prepareCaption(this.selectedActivators[a], this.selectedParks[p]),
              data: vals3
            });

            break;
        }
      });

      this.chartOption1 = {
        color: ['#4fc3f7', '#f74f8a'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: legend1,
          top: 20
        },
        grid: {
          top: 70,
          left: 90,
          right: 40,
          bottom: 90,
          containLabel: false
        },
        toolbox: {
          show: false,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: {show: true},
            dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            axisTick: {show: false},
            data: dataLabels1,
            name: 'Hours of Day (AVERAGE)',
            nameLocation: 'middle',
            nameRotate: 0,
            nameGap: 60,
            axisLabel: {
              rotate: 90,
              interval: 'auto',
              inside: false,
            },
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: (this.selectedActivatorsType === 'daily_usage' || this.selectedActivatorsType === 'occupancy') ? 'Percentage' : 'Number of Activations',
            nameLocation: 'middle',
            nameRotate: 90,
            nameGap: 60,
            // max: 200
          }
        ],
        series: series1
      };

      this.chartOption2 = {
        color: ['#4fc3f7', '#f74f8a'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: legend2,
          top: 20,
        },
        grid: {
          top: 70,
          left: 90,
          right: 40,
          bottom: 120,
          containLabel: false
        },
        toolbox: {
          show: false,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: {show: true},
            dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            axisTick: {show: false},
            data: dataLabels2,
            name: 'Days of Week (AVERAGE)',
            nameLocation: 'middle',
            nameRotate: 0,
            nameGap: 90,
            axisLabel: {
              rotate: 90,
              interval: 'auto',
              inside: false,
            },
            splitLine: {
              show: true,
              alignWithLabel: true,
              interval: (index, label) => {
                return (index > 0) && (index % 24 === 0);
              },
              lineStyle: {
                color: '#505050',
              }
            },
            splitArea: {
              show: true,
              alignWithLabel: true,
              interval: (index, label) => {
                return (index % 24 === 0);
              },
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: (this.selectedActivatorsType === 'daily_usage' || this.selectedActivatorsType === 'occupancy') ? 'Percentage' : 'Number of Activations',
            nameLocation: 'middle',
            nameRotate: 90,
            nameGap: 60,
            // max: 200
          }
        ],
        series: series2
      };

      this.chartOption3 = {
        color: ['#4fc3f7', '#f74f8a'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: legend3,
          top: 20,
        },
        grid: {
          top: 70,
          left: 90,
          right: 40,
          bottom: 100,
          containLabel: false
        },
        toolbox: {
          show: false,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: {show: true},
            dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        calculable: true,
        dataZoom: [
          {
            type: 'slider',
            show: true,
            start: 0,
            end: 100,
            left: 130,
            right: 130,
          }
        ],
        xAxis: [
          {
            type: 'category',
            axisTick: {show: false},
            data: dataLabels3,
            name: this.selectedActivatorsType === 'occupancy' ? 'Weeks of Month (AVERAGE)' : 'CONTINUOUS data over selected time range',
            nameLocation: 'middle',
            nameRotate: 0,
            nameGap: 40
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: (this.selectedActivatorsType === 'daily_usage' || this.selectedActivatorsType === 'occupancy') ? 'Percentage' : 'Number of Activations',
            nameLocation: 'middle',
            nameRotate: 90,
            nameGap: 60,
            // max: 200
          }
        ],
        series: series3
      };
    }, (err) => {
      this.isLoadingResults = false;
    }, () => {
      this.isLoadingResults = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/crowd/reports.crowd.component.ts